/**
 * Created by contrapro on 03/04/2018
 */

import { createStore, applyMiddleware, compose } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
// import createHistory from 'history/createHashHistory';
// import { routerMiddleware } from 'react-router-redux';
import rootReducer from './reducers';
import rootEpic from './epics';

const epicMiddleware = createEpicMiddleware(rootEpic);

// Create a history of your choosing (we're using a browser history in this case)
// export const history = createHistory();

// Build the middleware for intercepting and dispatching navigation actions
// const router_middleware = routerMiddleware(history);

export function configureStore() {
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

    // Add the reducer to your store on the `router` key
    // Also apply our middleware for navigating
    const store = createStore(
        rootReducer,
        composeEnhancers(
            applyMiddleware(
                epicMiddleware,
                // router_middleware
            )
        )
    );
    return store;
}



// WEBPACK FOOTER //
// ./src/configureStore.js